import MonitoringMenu from './MonitoringMenu';

export default MonitoringMenu;
